import holidayService from './holidayService';

const GEO_LOCATION_API = '/depCity/v2';
export const getSearchData = async (val, locusIdPreselected = '') => {
  const bodySearchVal = {
    longitude: '',
    latitude: '',
    searchTerm: val,
    preSelectedCityLocusId: locusIdPreselected,
  };
  const bodyLatLong = {
    longitude: val?.longitude,
    latitude: val?.latitude,
    searchTerm: '',
    preSelectedCityLocusId: locusIdPreselected,
  };
  const body = val?.longitude ? bodyLatLong : bodySearchVal;
  return holidayService.post(GEO_LOCATION_API, body);
};
